import { forwardRef, type TextareaHTMLAttributes } from "react";

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  mono?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = "", mono = false, rows = 4, ...rest }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      className={`w-full px-3.5 py-2.5 bg-[var(--paper-2)] border border-[var(--rule)] text-[var(--ink)] placeholder:text-[var(--ink-4)] focus:border-[var(--ink)] focus:outline-none transition-colors resize-none leading-relaxed ${mono ? "mono text-[13px]" : "sans text-[14px]"} ${className}`}
      {...rest}
    />
  ),
);
Textarea.displayName = "Textarea";
